
<div :class="['card-profile-stats', { page }]">
  <div class="main">
    <h1 class="card-text">
      {{ card.year }} {{ card.set }} {{ card.player }}{{ card.number ? ` #${card.number}` : ''}}
    </h1>

    <card-item-chips
      profile
      :card="card"
      :is-public="isPublic"
    />
  </div>

  <section :class="['stats-grid', { page }]">
    <stat-item
      v-if="card.stats && card.stats.newestSale && card.stats.newestSale.price"
      label="Last Sold Price"
      :value="$filters.currency(card.stats.newestSale.price, { full: true })"
    />

    <stat-item
      v-if="card.stats && card.stats.newestSale && card.stats.newestSale.date"
      label="Last Sold Date"
      :value="$filters.date(card.stats.newestSale.date)"
    />

    <value-display
      v-if="!isPublic"
      subtle
      :confidence="isPrivateCard ? null : confidence"
      :value="currentValue"
      :estimated="isPrivateCard"
      :blur="!card.collectionCardId && confidence === 1"
    />

    <stat-item
      v-if="showPop"
      label="Pop"
      :value="card.pop ? $filters.number(card.pop) : 'N/A'"
    >
      <template #after>
        <icon-button
          v-if="!isPublic && card.profileId"
          class="pop-report"
          icon="menu_book"
          tooltip="View in depth population report"
          @click="showPopData"
        />
      </template>
    </stat-item>

    <stat-item
      v-if="!isPublic && gradeRatio"
      label="Grade Ratio Value"
      :value="$filters.currency(gradeRatio.ratio * gradeRatio.currentValue)"
    >
      <template #after>
        <span>
          <helper-icon :help-text="`Graded Ratio Value attempts to estimate the value of a card that hasn't sold in the last year using a recent comp from another grade of this same card. Using sales in the past where this card sold around the same time as the ${gradeRatio.condition} copy, the ratio was found to be ${gradeRatio.ratio}. Using the current value of the ${gradeRatio.condition} we have determined the value of this card.`" />
          <external-link href="https://cardladder.zendesk.com/hc/en-us/articles/13406278121751-Grade-Ratio-Value" />
        </span>
      </template>
    </stat-item>

    <stat-item
      v-if="card.cert && card.collectionCardId"
      label="Graded Cert #"
      :value="card.cert"
    >
      <template #after>
        <external-link
          v-if="certLink"
          :href="certLink"
          @click.native="$copyText(card.cert.toString())"
        />
      </template>
    </stat-item>

    <stat-item
      v-if="cardId && card.stats && card.stats.marketCap"
      label="Market Cap"
      :value="$filters.currency(card.stats.marketCap)"
    >
      <template #after>
        <helper-icon help-text="Market Cap is simply the current value multiplied by the population" />
      </template>
    </stat-item>

    <stat-item
      v-if="card.collectionCardId && card.datePurchased"
      label="Date Purchased"
      :value="$filters.date(card.datePurchased)"
    />

    <stat-item
      v-if="card.collectionCardId && card.sold && card.dateSold"
      label="Date Sold"
      :value="$filters.date(card.dateSold)"
    />

    <stat-item
      v-if="gapExists && !card.collectionCardId"
      :label="card.stats.gap > 0 ? 'Undervalued' : 'Overvalued'"
      :value="gapValue"
    >
      <pro-label
        v-if="isPublic"
        tooltip="Go Pro today to see if this card is due for a price jump"
        as="nuxt-link"
        to="/pricing"
      />

      <template #after>
        <helper-icon v-if="!isPublic" help-text="Undervalued/Overvalued is the percentage difference between the Last Sold Price and the CL Value algorithm." />
      </template>
    </stat-item>
  </section>

  <collection-card-badges @clickEstimation="handleClickEstimationBadge" :card="card" />
  <admin-card-badges :card="card" />
</div>
